module.exports = __webpack_public_path__ + "static/media/no-image-16-9.63714aa4.jpg";